import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
	userInfo:{//用户信息
		userInfoObj:{}, //用户名等信息
		/*rankObj:{}, //认证情况信息*/
		viewObj:{}, //浏览情况信息
		vip:{
			check:0, //是否浏览过了
			count:0, //看过多少
			total:0, //免费额度
			vip:-1 //是否vip -1表示不确定
		}
	}, 
	placeObj:{
		place:[], //城市列表一级
		place_sub:{} //城市列表二级
	},
	tradeObj:{
		trade:[], //领域列表一级
		trade_sub:[], //领域列表二级
	},
	talentArr:[], //人才列表
	localObj:{//机构类型
		gb_hy:[],
		kind:[],
		place:[],
		place_sub:{}
	},
	qrcode:{//二维码
		wx_img_home : "",
        wx_img_mine : "",
        wx_img_mine_people : "",
        wx_img_mine_wallet : "",
        wx_img_sample : "",
        wx_img_target : ""
	}
}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js